// extracted by mini-css-extract-plugin
export var background = "index-module--background--3DkEb";
export var letters = "index-module--letters--3OzwH";